import { render, staticRenderFns } from "./editlotmanage.vue?vue&type=template&id=3c6f2e40&scoped=true"
import script from "./editlotmanage.vue?vue&type=script&lang=js"
export * from "./editlotmanage.vue?vue&type=script&lang=js"
import style0 from "./editlotmanage.vue?vue&type=style&index=0&id=3c6f2e40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6f2e40",
  null
  
)

export default component.exports